import { Data } from "@angular/router";

export class Lead {
    public cognome:string;
    public nome:string;
    public telefono:string;
    public cellulare:string;
    public email:string;
    public privacy1:boolean;
    public privacy2:boolean;
    public TransId:string;
    public cap:string;
    public Note:string;
    public dataappuntamento:string;
    public ConsensoComunicazioniPromozionali:boolean;
    public ConsensoCessioneSocietaPartner:boolean;
    public ConsensoCessioneTerzi:boolean;
    public Url:string;

    constructor()
    {
        this.cognome="";
        this.nome="";
        this.telefono="";
        this.cellulare="";
        this.email="";
        this.privacy1=false;
        this.privacy2=false;
        this.TransId="";
        this.cap="";
        this.Note="";
        this.dataappuntamento=null;
        this.ConsensoComunicazioniPromozionali=false;
        this.ConsensoCessioneSocietaPartner=false;
        this.ConsensoCessioneTerzi=false;
        this.Url="https://www.fornituralternativa.com";

    }
}



// WEBPACK FOOTER //
// ./src/app/model/lead.ts